import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const DashboardLayoutContext = createContext(null);

export function DashboardLayoutProvider({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleSubmenu = useCallback((menuName) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  }, []);

  const openSidebar = useCallback(() => setSidebarOpen(true), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const toggleSidebar = useCallback(() => setSidebarOpen(prev => !prev), []);

  const expandMenu = useCallback((menuName) => {
    // Bail out with the same object when already expanded — a new object
    // identity here re-renders every consumer of the context value, and
    // effects that depend on it (e.g. the tutorial spotlight) would loop
    setExpandedMenus(prev => (prev[menuName] ? prev : {
      ...prev,
      [menuName]: true,
    }));
  }, []);

  const value = useMemo(() => ({
    sidebarOpen,
    setSidebarOpen,
    openSidebar,
    closeSidebar,
    toggleSidebar,
    expandedMenus,
    setExpandedMenus,
    toggleSubmenu,
    expandMenu,
  }), [sidebarOpen, expandedMenus, openSidebar, closeSidebar, toggleSidebar, toggleSubmenu, expandMenu]);

  return (
    <DashboardLayoutContext.Provider value={value}>
      {children}
    </DashboardLayoutContext.Provider>
  );
}

export function useDashboardLayout() {
  const context = useContext(DashboardLayoutContext);
  if (!context) {
    return null;
  }
  return context;
}

export default DashboardLayoutContext;
